module.exports = __webpack_public_path__ + "static/media/media_it-min.4b48003f.jpg";